import React, { useEffect, useState } from 'react';
import $i18n from '../../../../i18n';
import { Link, Icon, Loading } from '@b-design/fusion';
import { history } from 'ice';
import Requests from '@/services/request';

import './index.less';

const Approvals: React.FC<{ spaceId: string }> = ({ spaceId }) => {
  const [msg, setMsg] = useState<any>([]);
  const [totalProcess, setTotalProcess] = useState(0);
  const [totalRequest, setTotalRequest] = useState(0);
  const [loading, setLoading] = useState(false);

  const getApprovalsInit = async () => {
    if (!spaceId) {
      return;
    };
    try {
      setLoading(true);
      const userInfo = await Requests.get('/rest/intercnn/user/info');
      if (userInfo.status === 4) {
        history?.push('/login?safetyModalVisible=true');
        return;
      }
      Requests.get('/rest/intercnn/approve/query', {
        approveTarget: spaceId,
        status: 'FINISHED',
      }).then((res) => {
        if (res) {
          setTotalProcess(res.total);
        }
      });

      Requests.get('/rest/intercnn/approve/query', {
        sourceSpaceId: spaceId,
        createUid: userInfo?.accountId,
      }).then((res) => {
        if (res) {
          setTotalRequest(res.total);
        }
      });

      Requests.get('/rest/intercnn/approve/query', {
        currentPage: 1,
        pageSize: 2,
        approveTarget: spaceId,
        status: 'PROCESSING',
      }).then((data) => {
        if (data) {
          const { list = [] } = data;
          const arr: any = [];
          list.forEach((item, index) => {
            arr.push({
              key: index,
              name: item.createName,
              title: item.extInfo?.space?.name,
              titleApp: item.extInfo?.description?.name,
            });
          });
          setMsg(arr);
          setLoading(false);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getApprovalsInit();
  }, [spaceId]);

  return (
    <div className="overview-approvals">
      <div className="overview-approvals-title">
        <h1>{$i18n.get({ id: 'aopf.pages.overview.Approvals', dm: '审批' })}</h1>
        <Link
          onClick={() => history?.push(`/approvals?spaceId=${spaceId}`)}
        >
          {$i18n.get({ id: 'aopf.pages.overview.Approvals.More', dm: '更多' })}
        </Link>
      </div>
      <Loading visible={loading} style={{ width: '100%' }}>
        <div className="approvals-content">
          <div className="content-message">
            {msg.length > 0 ? (
              msg.map((item) => (
                <div
                  key={item.key}
                  className="message-container"
                  onClick={() => history?.push(`/approvals?spaceId=${spaceId}`)}
                >
                  <span className="superapp_iconfont superapp_icon-jurassic_radio" />
                  <div className="message-title">
                    <span className="msg-name">{item.name}</span>{' '}
                    {$i18n.get({
                      id: 'aopf.pages.overview.sent.the.version.release.request.to',
                      dm: '发起了审批',
                    })}{' '}
                    <span className="msg-name">{item.title ? item.title : item.titleApp}</span>{' '}
                  </div>
                  <div className="message-arrow-right">
                    <Icon type="arrow--right" size="small" />
                  </div>
                </div>
              ))
            ) : (
              <div className="approvals-empty-content">
                {$i18n.get({
                  id: 'aopf.pages.overview.Approvals.empty.msg',
                  dm: '没有待处理的审批任务。',
                })}
              </div>
            )}
          </div>

          <div className="content-processed content-common">
            <div className="total-num">{totalProcess}</div>
            <div className="total-div">
              <div className="div-title">
                {$i18n.get({ id: 'aopf.pages.overview.Processed', dm: '我的已处理' })}
              </div>
              <Link
                onClick={() => history?.push(`/approvals?defaultActiveKey=Completed&spaceId=${spaceId}`)}
              >
                {$i18n.get({ id: 'aopf.pages.overview.view.all', dm: '查看全部' })}
              </Link>
            </div>
          </div>
          <div className="content-request content-common">
            <div className="total-num">{totalRequest}</div>
            <div className="total-div">
              <div className="div-title">
                {$i18n.get({ id: 'aopf.pages.overview.Request', dm: '我的请求' })}
              </div>
              <Link
                onClick={() => history?.push(`/approvals?defaultActiveKey=MyRequest&spaceId=${spaceId}`)}
              >
                {$i18n.get({ id: 'aopf.pages.overview.view.all', dm: '查看全部' })}
              </Link>
            </div>
          </div>
        </div>
      </Loading>
    </div>
  );
};

export default Approvals;
